import { useRef } from 'react';
import Landing from './Pages/Landing';
import Navbar from './Pages/MainLayout';
import ScrollToTop from './Components/ScrollToTopBtn';
import './App.css';

function App() {
  const aboutRef = useRef();
  const expRef = useRef();
  const projectsRef = useRef();

  return (
    <>
      <Navbar
        aboutRef={aboutRef}
        expRef={expRef}
        projectsRef={projectsRef}
      />
      <ScrollToTop />
      <Landing
        aboutRef={aboutRef}
        expRef={expRef}
        projectsRef={projectsRef}
      />
    </>
  );
}

export default App;
